import axios from 'axios'
import apiUrl from '../_const'

export default {
  getUser () {
    return axios.get(apiUrl.USER_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  updateUser ({commit}, data) {
    return axios.post(apiUrl.USER_URL, {
      company: data.company,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      emailBilling: data.emailBilling,
      birthday: data.birthday,
      street: data.street,
      zipCode: data.zipCode,
      city: data.city,
      tel: data.tel,
      mobile: data.mobile
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  registerUser ({commit}, data) {
    return axios.post(apiUrl.REGISTER_URL + '?g-recaptcha-response=' + data.captcha, {
      type: data.type,
      company: data.company,
      companyVatID: data.companyVatID,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      emailBilling: data.emailBilling,
      birthday: data.birthday,
      street: data.street,
      houseNumber: data.houseNumber,
      zipCode: data.zipCode,
      city: data.city,
      country: data.country,
      tel: data.tel,
      mobile: data.mobile
    }, {}).catch((error) => {
      return new Error(error)
    })
  },
  confirmUser ({commit}, id) {
    return axios.get(apiUrl.CONFIRM_URL + id, {}, {}).catch((error) => {
      return new Error(error)
    })
  },
  confirmPayment ({commit}, data) {
    return axios.post(apiUrl.CONFIRMPAYMENT_URL, data).catch((error) => {
      return new Error(error)
    })
  },
  changePayment () {
    return axios.get(apiUrl.CHANGEPAYMENT_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/user.js